<template>
  <section class="mb-0 auto-height" id="renewal">
      <div class="container">
        <h3 class="text-center mb-0">都更專區</h3>
        <br>
        <button type="button" :class="'btn btn-secondary' + (showTypeIdx===0?' selected':'')" @mouseover="showTypeIdx=0;showRenewalIdx=0;">都更相關法令</button>
        <button type="button" :class="'btn btn-secondary' + (showTypeIdx===1?' selected':'')" @mouseover="showTypeIdx=1;showRenewalIdx=0;">目前執行中</button>
        <button type="button" :class="'btn btn-secondary' + (showTypeIdx===2?' selected':'')" @mouseover="showTypeIdx=2;showRenewalIdx=0;">危老重建</button>
        <br>
        <div v-if="showTypeIdx===0" id="newsTableBorder">
          <table class="table table-borderless" id="newsTable">
            <thead>
              <tr>
                <th scope="col">日期</th>
                <th scope="col">標題</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(law, i) in paginateLaws(currentPage)" :key="i">
                  <td>{{ law.date }}</td>
                  <a :href="law.pdf" target="pdf"><td class="lawTitle clickable">{{ law.title }}</td></a>
              </tr>
              <tr>
                <td colspan="2">
                  <button type="button" :class="'btn btn-secondary' + (currentPage>1?'':' hidden')" @click="currentPage-=1">上一頁</button>
                  第 {{ currentPage }} 頁
                  <button type="button" :class="'btn btn-secondary' + (currentPage<laws.length/5?'':' hidden')" @click="currentPage+=1">下一頁</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <swiper v-if="displayArr.length>0" :options="swiperOption" :key="showTypeIdx">
            <swiper-slide v-for="(c, i) in displayArr" :key="i">
                <div class="card clickable" width="50%" id ="case-list-card" @click="showRenewalIdx=i;showModal=true;">
                    <img :src="c.img" class="card-img-top" :alt="c.title">
                    <div class="card-body">
                    <h5 class="card-title">{{ c.title }}</h5>
                    <p class="card-text">{{ c.date }}</p>
                    <p class="card-text"><small class="text-muted">{{ c.long_title }}</small></p>
                    </div>
                </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 44"><path d="M0,22L22,0l2.1,2.1L4.2,22l19.9,19.9L22,44L0,22L0,22L0,22z"></svg></div>
            <div class="swiper-button-next" slot="button-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 44"><path d="M27,22L27,22L5,44l-2.1-2.1L22.8,22L2.9,2.1L5,0L27,22L27,22z"></svg></div>
          </swiper>
          <p v-else>※ 敬請期待</p>
        </div>
      </div>
      <RenewalModal v-if="showRenewalIdx < displayArr.length" :renewal="displayItem" :class="{noshow: !showModal}" @close="showModal=false" />
  </section>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import RenewalModal from './RenewalModal.vue'

export default {
  name: 'Renewal',
  components: {
    swiper,
    swiperSlide,
    RenewalModal,
  },
  props: {
    laws: Array,
    renewals: Array,
  },
  data() {
    return {
      showTypeIdx: 1,
      showRenewalIdx: 0,
      currentPage: 1,
      showModal: false,
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 25,
        slidesPerGroup: 3,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          992: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
        }
      }
    }
  },
  computed: {
    displayArr: function() {
      if (this.showTypeIdx === 0) {
        return this.laws
      }
      return this.renewals[this.showTypeIdx-1]
    },
    displayItem: function() {
      return this.displayArr[this.showRenewalIdx]
    }
  },
  methods: {
    paginateLaws(page) {
      return this.laws.slice((page-1)*5, page*5)
    }
  }
}
</script>

<style scoped>
#newsTableBorder {
  border: 2px solid rgb(245, 166, 21);
  border-radius: 5px;
}
/* a{
  color: #222;
}
a:hover{
  text-decoration: none;
} */
.modal-default-button {
  float: right;
}
.hidden {
  visibility: hidden;
}
#newModal {
  display: block;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  /* transition: opacity .3s ease; */
}
.modal-mask.noshow {
  display: none;
}
.newsPicDiv {
   display:inline-block;
   width:100%;
}

@media (min-width: 992px) {
  .newsPicDiv {
   display:inline-block;
   width:33%;
  }
  .modal-dialog {
    max-width: 65%;
  }
}
/* .card {
  margin-left: 1.9%;
  margin-right: 1.9%;
} */
.pdf {
  margin-left: 2.5%;
}
.modal-body {
  overflow-y: visible;
  background-color: #222;
}
.modal-footer {
  overflow-y: auto;
  display: block;
  max-height: 42vh;
}
@media (min-width: 992px) {
  .modal-footer {
    max-height: 34.5vh;
  }
}
.swiper-pagination >>> .swiper-pagination-bullet-active {
  background-color:  rgba(235, 159, 18, 0.842);;
}
.swiper-button-next, .swiper-button-prev {
    background-image: none;
    fill: rgba(235, 159, 18, 0.842);
}
a:hover {
  text-decoration: none;
}
</style>